module.exports = __webpack_public_path__ + "img/banner04.532ab198.jpg";